import React from 'react';
import CheckList from '../../lib/CheckList/CheckList';
import PhoneInput from 'react-phone-number-input';
import { ComponentsContext } from '../../contexts/componentsContext';
import TimeSelect from '../TimeSelect/TimeSelect';
import { Input } from '../../flayr-components/Input/Input';

interface IInputSectionProps {
  name?: string;
  value?: string;
  type?: string;
  placeholder?: string;
  autoFocus?: boolean;
  checkListItems?: { title: string; subTitle: string }[];
  country?: string;
  onChange?: (e: any) => void;
}

const InputSection: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<IInputSectionProps>>
> = ({
  name,
  value,
  type = 'text',
  checkListItems = [],
  placeholder,
  onChange,
  country,
  autoFocus,
}) => {
  const ref = React.useRef<any>();

  function handlePhoneInputChange(phone) {
    onChange?.({
      target: {
        name,
        value: phone,
      },
    });
  }

  React.useEffect(() => {
    if (autoFocus) {
      setTimeout(() => {
        const input = ref.current;
        input?.focus?.();
      }, 600);
    }
  }, [autoFocus]);

  return (
    <div>
      {!['mobile', 'time'].includes(type) && (
        <Input
          type={type as any}
          name={name}
          ref={ref}
          value={value}
          placeholder={placeholder || `What's your ${name}?`}
          size="lg"
          validation={['required', ...((type === 'email' && ['email']) || [])]}
          runValidateOnEvents="onBlur"
          onChange={onChange}
          autoExpandHeight
          className="text-gray-700"
          rows={6}
        />
      )}
      {type === 'time' && (
        <TimeSelect
          ref={ref}
          name={name}
          value={value}
          placeholder={placeholder}
          size="lg"
          className="text-gray-700"
          validation={[
            { rule: 'required', message: 'Finish Time is required' },
          ]}
          onChange={onChange}
        />
      )}
      {type === 'mobile' && (
        <PhoneInput
          defaultCountry={country?.toUpperCase() as any}
          placeholder={placeholder || `What's your ${name}`}
          inputComponent={Input}
          onChange={handlePhoneInputChange}
          value={value}
          name={name}
          ref={ref}
          numberInputProps={{
            size: 'lg',
            validation: ['required'],
            className: 'text-gray-700',
          }}
        />
      )}
      {!!checkListItems.length && (
        <div className="mt-8">
          <CheckList
            items={checkListItems}
            titleClassName="lg:text-2xl"
            subTitleClassName="lg:text-lg lg:text-white lg:opacity-75"
          />
        </div>
      )}
    </div>
  );
};
export default InputSection;
